// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c34baf2","239":"b2522453","455":"b00fbbf7","884":"b29e28de"}[chunkId] + ".chunk.js";
};